// src/components/PrivacyPolicy.js
import React from 'react';
import logo from '../assets/Editvibelogo1.svg';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => (
  <div className="evmp-privacy-page">
    {/* top‑left logo */}
    <a
      href="https://app.editvibe.ai"
      className="evmp-privacy-logo-link"
    >
      <img
        src={logo}
        alt="EditVibe Logo"
        className="evmp-privacy-logo"
      />
    </a>

    {/* main content */}
    <h1 className="evmp-privacy-title">Privacy Policy</h1>
    <p className="evmp-privacy-updated"><em>Last updated: May 14, 2025</em></p>

    <h2 className="evmp-privacy-section-title">1. Information We Collect</h2>
    <ul className="evmp-privacy-list">
      <li className="evmp-privacy-list-item"><strong>Account Information:</strong> Name, email, password.</li>
      <li className="evmp-privacy-list-item"><strong>Usage Data:</strong> Model selection, processing times, prompts.</li>
      <li className="evmp-privacy-list-item"><strong>Uploaded Content:</strong> Videos you upload for editing (we do not share externally).</li>
      <li className="evmp-privacy-list-item"><strong>Device &amp; Log Data:</strong> IP address, browser type, crash data.</li>
    </ul>

    <h2 className="evmp-privacy-section-title">2. How We Use Your Information</h2>
    <ul className="evmp-privacy-list">
      <li className="evmp-privacy-list-item"><strong>Provide &amp; Improve Service:</strong> Process edits, train and refine AI models.</li>
      <li className="evmp-privacy-list-item"><strong>Account Management:</strong> Authentication, billing, support.</li>
      <li className="evmp-privacy-list-item"><strong>Communications:</strong> Respond to requests, send updates, marketing (with opt‑out).</li>
      <li className="evmp-privacy-list-item"><strong>Security &amp; Compliance:</strong> Detect abuse, enforce policies, comply with law.</li>
    </ul>

    <h2 className="evmp-privacy-section-title">3. Data Sharing &amp; Disclosure</h2>
    <p className="evmp-privacy-text">
      We do not sell your data. We may share information with:
    </p>
    <ul className="evmp-privacy-list">
      <li className="evmp-privacy-list-item"><strong>Service Providers:</strong> Cloud hosting partners, payment processors, team members/contractors bound by confidentiality.</li>
      <li className="evmp-privacy-list-item"><strong>Legal Authorities:</strong> When required by law or to protect rights.</li>
      <li className="evmp-privacy-list-item"><strong>Business Transfers:</strong> In connection with a merger, acquisition, or sale of assets.</li>
    </ul>

    <h2 className="evmp-privacy-section-title">4. Data Retention</h2>
    <ul className="evmp-privacy-list">
      <li className="evmp-privacy-list-item"><strong>User Content:</strong> Stored until you delete your account or as required by partner services.</li>
      <li className="evmp-privacy-list-item"><strong>Account &amp; Usage Data:</strong> Retained for up to 3 years after account deletion for legal compliance.</li>
    </ul>

    <h2 className="evmp-privacy-section-title">5. Cookies &amp; Tracking</h2>
    <p className="evmp-privacy-text">
      We use cookies and similar technologies to:
    </p>
    <ul className="evmp-privacy-list">
      <li className="evmp-privacy-list-item">Keep you logged in</li>
      <li className="evmp-privacy-list-item">Analyze site usage (e.g., Google Analytics)</li>
      <li className="evmp-privacy-list-item">Offer personalized features</li>
    </ul>
    <p className="evmp-privacy-text">
      You can manage cookies via your browser settings, but disabling them may reduce functionality.
    </p>

    <h2 className="evmp-privacy-section-title">6. Your Rights</h2>
    <ul className="evmp-privacy-list">
      <li className="evmp-privacy-list-item">Access the data we hold about you</li>
      <li className="evmp-privacy-list-item">Correct or update inaccurate information</li>
      <li className="evmp-privacy-list-item">Delete your data or account</li>
      <li className="evmp-privacy-list-item">Restrict or object to certain processing</li>
      <li className="evmp-privacy-list-item">Request data portability</li>
    </ul>
    <p className="evmp-privacy-text">
      To exercise rights, contact us at <a href="mailto:info@editvibe.ai" className="evmp-privacy-link">info@editvibe.ai</a>.
    </p>

    <h2 className="evmp-privacy-section-title">7. Children’s Privacy</h2>
    <p className="evmp-privacy-text">
      Our Service is not directed to children under 16. We do not knowingly collect data from minors. If you believe we have, please contact us to remove it.
    </p>

    <h2 className="evmp-privacy-section-title">8. Changes to This Policy</h2>
    <p className="evmp-privacy-text">
      We may update this Privacy Policy. We’ll post the new policy here with an updated date. Continued use constitutes acceptance of changes.
    </p>

    <h2 className="evmp-privacy-section-title">9. Contact Us</h2>
    <p className="evmp-privacy-text">
      For privacy inquiries: <a href="mailto:info@editvibe.ai" className="evmp-privacy-link">info@editvibe.ai</a>
    </p>
  </div>
);

export default PrivacyPolicy;
